import axios from "axios";
import { api } from "./api";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // Or AsyncStorage for mobile
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const Createstaff = async (data) => {
  return await api.post("add/staff", data); // ✅ correct endpoint, NO /:id
};
export const fetchstaff = async (addUrl = "") => {
  let url = `staff/v2/list?${addUrl}`;
  return await api.get(url);
};

export const fetchstaffdata = async (addUrl = "") => {
  let url = `staff/list?${addUrl}`;
  return await api.get(url);
};

export const GetStaffId = async (data) => {
  return await api.get("new/staff", data); // ✅ correct endpoint, NO /:id
};
export const Staffupdate = async (data) => {
  return await api.post("Staff/updateDetails", data); // ✅ correct endpoint, NO /:id
};
export const statusupdate = async (data) => {
  return await api.post("staff/status", data); // ✅ correct endpoint, NO /:id
};
// export const getstaffwithid = async (id) => {
//   return await api.get(`staff/v2/details?id=${id}`);
// };

export const getstaffwithid = async (id, params = {}) => {
  return await api.get(`staff/v2/details`, {
    params: {
      id: id,
      ...params,
    },
  });
};
